import { Component, OnInit } from '@angular/core';
import {WizardService} from '../../../services/wizard.service';
import {StepConfig} from '../../../configuration/step-config';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: []
})
export class NavComponent implements OnInit {

  constructor(public wizardService: WizardService) { }

  ngOnInit() {
  }

  isStepAllowed(step: StepConfig): boolean {
    if (this.wizardService.navigationForbidden) {
      return false;
    }
    return this.wizardService.shouldAllowToNavigate(step);
  }

  isStepCompleted(step: StepConfig): boolean {
    if (this.wizardService.navigationForbidden) {
      return true;
    }
    return this.wizardService.shouldAllowToNavigate(step);
  }

  isStepActive(step: StepConfig): boolean {
    return this.wizardService.isActive(step);
  }

}
